var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',_vm._b({staticClass:"badge",attrs:{"color":_vm.color(_vm.value),"x-small":_vm.xSmall}},'v-chip',_vm.$attrs,false),[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.spinnerSize,"color":"primary"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.value)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }